<lfw-toolbar>
  <ng-container toolbar-left>
    <lfw-toolbar-text text="{{ caption }}" />
    <span style="flex: 1 1 auto"></span>
  </ng-container>
  <ng-container toolbar-right>
    <lfw-toolbar-button label="{{ 'DIALOGS.CLOSE' | translate }}" icon="close" (click)="close()" />
  </ng-container>
</lfw-toolbar>
<lfw-order-details [order]="order" />
